<template>
  <v-layout ref="origin" style="overflow: auto; clear:both; max-height:calc(100vh - 17px);height:calc(100vh - 64px); cursor: grab;position: relative;padding-top:200px;">
           <v-snackbar
      class="mt-5"
      style="position:fixed;"
      v-if="localToast"
      v-model="localToast"
      :color="localToast.color"
      multi-line
      top
      right
      :timeout="localToast.timeout"
      >
        {{localToast.text}}
    </v-snackbar>
          <v-card :style="{ 'position': 'fixed', 'top': '120px', 'right': '20px', 'z-index': 50000, 'padding': '10px'}">
            <v-flex justify-space-between style="flex-wrap: nowrap">
            <v-icon>fas fa-search</v-icon>
            <span class="ma-2">{{Math.round(100 * mappingPanZoom)}}%</span>
            </v-flex>
          </v-card>

          <v-card class="hidden-sm-and-down" :style="{ 'position': 'fixed', 'top': '120px', 'right': '30%', 'width': '40%', 'z-index': 50000, 'padding': '10px'}">
           <v-slider
           @change="sliderChanged"
           style="cursor:pointer"
            :tick-labels="events"
            :value="3"
            min="0"
            max="3"
            ticks="always"
            tick-size="4"
            >
            <template v-slot:thumb-label="props">
              {{ date(props.value) }}
            </template>
          </v-slider>
          </v-card>
          
          <v-card v-if="showCallToAction && !submittedCallToAction" :style="{'pa-5': $vuetify.breakpoint.mdAndUp, 'position': 'fixed', 'bottom': '100px', 'left': '50px', 'z-index': 50000}">
          <v-card-title style="background-color: rgba(249, 191, 59, 1); margin-bottom:20px; padding-top:30px" class="justify-space-between">
            <span :class="{'subtitle-2': $vuetify.breakpoint.smAndDown, 'headline': $vuetify.breakpoint.mdAndUp}" style="display:block;">
              <b>Coming Soon!</b> Sign up now for access to the exclusive beta!
            </span>
            <v-btn icon  style="position: absolute; right: 10px; top: 0px" @click="toggleShow">
            <v-icon>fas fa-times</v-icon>
            </v-btn>
          </v-card-title>
          <v-flex row justify-space-around style="width:90%;height:100%" ml-3 align-top>
          <v-text-field @keyup.enter="submitCallToAction" v-model="ctaEmail" label="Your Email" hint="We promise to only email you about Org Owl!" persistent-hint type="email" style="max-width: 400px;" solo outlined filled>
          </v-text-field>
          <v-btn class="pulseButton" :loading="loading" @click="submitCallToAction" style="max-height: 100%; background-color:rgba(249, 191, 59, 1)" height="56" >
            Sign Up
          </v-btn>
          </v-flex>
        </v-card>
        <v-btn class="pulseButton" v-else-if="!submittedCallToAction" large :style="{'position': 'fixed', 'bottom': '70px', 'left': '10px', 'z-index': 50000, 'background-color':  'rgba(249, 191, 59, 1)'}" @click="toggleShow">
          <span style="">
            I'm interested!
          </span>
        </v-btn>
    <ChartBox ref="main" :panzoomInstance=instance :currentX=currentX :currentY=currentY :scale=panzoomScale :mappingScale=panzoomScale :whichPageToShow=mappingPanZoom :chart="selectedChart" :id="0" :ignoreMargin="false">
    </ChartBox>
  </v-layout>
</template>
<script>
import { dragscroll } from 'vue-dragscroll'
import panzoom  from 'panzoom'
import ChartBox from './ChartBox';
import axios from "axios";
axios.defaults.baseURL = "https://todotrackerapi.azurewebsites.net/";
export default {
    components: {ChartBox},
    props: ['org'],
    mounted() {
      window.addEventListener('resize', this.recursiveDrawLines)
      this.selectedChart = this.org.chart[3]
      this.instance = panzoom(this.$refs.main.$el, {
        zoomSpeed: 0.05,
        maxZoom: 1.5,
        minZoom: 0.2,
        onTouch: function(e) {
          if (e.target && e.target.className && e.target.className.indexOf && e.target.className.indexOf('icon') >=0) {
            return false
          }
        }
      })
      let debouncedRedraw = this.debounce(this.recursiveDrawLines, 300)

      if (this.$vuetify.breakpoint.smAndDown) {
        this.instance.zoomAbs(0,0,1.0)
        this.mappingPanZoom = 1.0
      } else {
        this.instance.zoomAbs(0,0,1)
        this.mappingPanZoom = 1.0
      }
      this.instance.on('zoom', (e) => {
        let transform = e.getTransform()
        this.mappingPanZoom = transform.scale
        this.currentX = transform.x
        this.currentY = transform.y
        debouncedRedraw()
      })
    },
    beforeDestroy: function () {
      window.removeEventListener('resize', this.recursiveDrawLines)
    },
    directives: {
      'dragscroll': dragscroll
    },
    data: function() {
      return {
        instance: null,
        panzoomScale: 1,
        mappingPanZoom: 1,
        selectedChart: [],
        selectedChartIndex: 3,
        events: [
          'First Hires',
          'Funding',
          'Restructure',
          'Acquired'
        ],
        dates: ['2001', '2004', '2013', '2019'],
        ctaEmail: '',
        loading: false,
        localToast: null,
        showCallToAction: true,
        submittedCallToAction: false,
        scale: (this.$vuetify.breakpoint.smAndDown ? 1.0 : 1.0),
        orgCardHeight: 250,
        orgCardWidth: 500,
        maxLinePointWidth: 0,
        maxLinePointHeight: 0,
        currentX: 0,
        currentY: 0,
      }
    },
    methods: {
      date (val) {
        return this.dates[val]
      },
      sliderChanged:  function (val) { 
        this.selectedChart = this.org.chart[val]
        this.selectedChartIndex = val
        window.scrollBy(1000,0)
      },
      get: function(uri, data = {}) {
        if (Object.keys(data).length > 0) {
          uri = `${uri}`;
        }

        return axios.get(uri, {
          headers: {},
          withCredentials: false
        });
      },
      post: function (uri, data) {
        return axios.post(uri, data, {
          headers: {'Content-Type': 'application/json'},
          withCredentials: false
        })
      },
      submitCallToAction: async function() {
        if (this.ctaEmail.length > 3 && this.ctaEmail.indexOf('@') > 0) {
          this.loading=true
          this.post('/api/OrgOwl/ImInterested', {'Email': this.ctaEmail, 'Comment': ''}).then(() => {
          this.submittedCallToAction = true
          this.localToast = {
            text: `Success! Looking forward to chatting!`,
            color: "success",
            timeout: 5000
          }
          }).catch(() => {
          this.localToast = {
            text: `Error processing your request, please email Support@StudiedSolutions.com`,
            color: "error",
            timeout: 5000
          }
          }).finally(() => {
            this.loading=false
          })
        } else {
          this.localToast = {
            text: `Please enter a valid email!`,
            color: "error",
            timeout: 5000
          }
        }
      },
      increaseScale: function() {
        if (this.scale < 1.5) {
          this.scale = this.scale + 0.05
        }
      },
      decreaseScale: function() {
        if (this.scale > 0.2) {
          this.scale = this.scale - 0.05
        }
      },
      toggleShow: function() {
        this.showCallToAction = !this.showCallToAction
      },
      recursiveDrawLines: async function() {
        let nodes = this.$refs.main
        nodes.drawLines()
      },
      debounce: function (func, wait, immediate) {
  var timeout;

  // This is the function that is actually executed when
  // the DOM event is triggered.
  return function executedFunction() {
    // Store the context of this and any
    // parameters passed to executedFunction
    var context = this;
    var args = arguments;

    // The function to be called after 
    // the debounce time has elapsed
    var later = function() {
      // null timeout to indicate the debounce ended
      timeout = null;

      // Call function now if you did not on the leading end
      if (!immediate) func.apply(context, args);
    };

    // Determine if you should call the function
    // on the leading or trail end
    var callNow = immediate && !timeout;
	
    // This will reset the waiting every function execution.
    // This is the step that prevents the function from
    // being executed because it will never reach the 
    // inside of the previous setTimeout  
    clearTimeout(timeout);
	
    // Restart the debounce waiting period.
    // setTimeout returns a truthy value (it differs in web vs node)
    timeout = setTimeout(later, wait);
	
    // Call immediately if you're dong a leading
    // end execution
    if (callNow) func.apply(context, args);
  };
}
    }
}
</script>

<style lang="scss" scoped>

@keyframes shadow-pulse
{
     0% {
          box-shadow: 0 0 0 0px rgba(249, 191, 59, 0.5);
     }
     100% {
          box-shadow: 0 0 0 35px rgba(249, 191, 59, 0);
     }
}

.pulseButton {
   animation: shadow-pulse 2s infinite;
}

</style>
